import { render, staticRenderFns } from "./TaskCommit.vue?vue&type=template&id=6b91b36a&scoped=true&"
import script from "./TaskCommit.vue?vue&type=script&lang=js&"
export * from "./TaskCommit.vue?vue&type=script&lang=js&"
import style0 from "./TaskCommit.vue?vue&type=style&index=0&id=6b91b36a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91b36a",
  null
  
)

export default component.exports